import cookie from 'cookie-utils-js';
import { getAppInfo } from '@/api/app';
import { capitalize } from '@/utils/util';

const resetState = {
	appid: '',
	redirectURL: ''
};

const actions = {
	async updateAppBaseInfo({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_BASE_INFO', {
			appid: payload.appid,
			redirectURL: payload.redirectURL
		});
	},

	async resetAppState({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_BASE_INFO', {
			...resetState
		});
	},
}

export default actions;
